import { useEffect } from "react";
import {
  buildPageGraph,
  DEFAULT_OG_IMAGE,
  seoByPath,
  SITE_NAME,
  SITE_URL,
} from "../../data/seo";

const setMeta = (attribute, key, value) => {
  const selector = `meta[${attribute}="${key}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value);
};

export const SeoHead = ({ path }) => {
  const entry = seoByPath[path] || seoByPath["/"];
  const canonical = path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
  const image = `${SITE_URL}${DEFAULT_OG_IMAGE}`;

  useEffect(() => {
    document.title = entry.title;

    setMeta("name", "description", entry.description);
    setMeta("property", "og:title", entry.title);
    setMeta("property", "og:description", entry.description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", entry.title);
    setMeta("name", "twitter:description", entry.description);
    setMeta("name", "twitter:image", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("property", "og:image:alt", "I.T.O. Insurance Agency logo");

    let jsonLd = document.getElementById("seo-jsonld");
    if (!jsonLd) {
      jsonLd = document.createElement("script");
      jsonLd.id = "seo-jsonld";
      jsonLd.type = "application/ld+json";
      document.head.appendChild(jsonLd);
    }
    jsonLd.textContent = JSON.stringify(buildPageGraph(path));
  }, [entry.title, entry.description, canonical, image, path]);

  return null;
};
